<script>
import { VAlert } from 'vuetify/lib'

export default {
    extends: VAlert,
    props: {
        border: {
            default: 'left',
        },
        coloredBorder: {
            default: true,
        },
        elevation: {
            default: '2',
        }
    }
}
</script>
